/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
const getQueryString = (queryString = '', param = '') => {
  const params = queryString.split('&');
  const reqParams = params.filter((ele, i) => {
    const paramVal = ele.split('=');
    if (paramVal[0] === param) {
      return ele;
    }
  });
  const qryStr = reqParams.length > 0 ? reqParams[0].split('=')[1] : '';
  return qryStr;
};
export default getQueryString;
